import { render, staticRenderFns } from "./BenefitsCategory.vue?vue&type=template&id=20536725&scoped=true&lang=html&"
import script from "./BenefitsCategory.vue?vue&type=script&lang=js&"
export * from "./BenefitsCategory.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsCategory.vue?vue&type=style&index=0&id=20536725&lang=sass&scoped=true&"
import style1 from "./BenefitsCategory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20536725",
  null
  
)

export default component.exports